<template>
  <div v-if="section?.length" class="flex flex-col gap-y-56">
    <Container
      v-for="(block, index) in section"
      :key="block.id"
      class="w-full empty:hidden"
      :width="getBlockWidth(block.type)"
    >
      <BlockRenderer
        :id="block.id"
        :block-position="index + 1"
        :data-test="block.id"
        :hidden-devices="block.hiddenDevices"
        :props="block.props"
        :type="block.type"
        :with-bottom-margin="false"
      />
    </Container>
  </div>
</template>

<script setup lang="ts">
import type { _ApiBlock } from '@backmarket/http-api/src/api-specs-content/models/block'

import { getBlockWidth } from '../utils/blockWidth'

import BlockRenderer from './BlockRenderer/BlockRenderer.vue'
import Container from './Container.vue'

defineProps<{ section?: _ApiBlock[] }>()
</script>
